import { useQuery } from "@tanstack/react-query";
import { meiliClient } from "../../../utils/meiliClient";

/**
 * Ask Meili for facet counts for the given fields.
 * If the index doesn't allow faceting (not filterable), we catch and return {}.
 */
export function useFacets(
  jobId?: string | null,                  // kept for compatibility; ignored
  fields: unknown = [],
  indexName = "applications"
) {
  // Coerce to a clean string array
  const fieldList: string[] = Array.isArray(fields)
    ? (fields as any[]).filter((v) => typeof v === "string")
    : typeof fields === "string"
    ? [fields]
    : fields && typeof fields === "object"
    ? Object.values(fields as Record<string, any>).filter((v) => typeof v === "string")
    : [];

  return useQuery({
    queryKey: ["meiliFacets", indexName, JSON.stringify(fieldList.slice().sort()), jobId ?? null],
    enabled: fieldList.length > 0,
    queryFn: async () => {
      const index = meiliClient.index(indexName);
      try {
        const res = await index.search("", {
          facets: fieldList,
          limit: 0,
        });
        return (res as any).facetDistribution || {};
      } catch {
        // If fields aren't filterable, just return no facets
        return {};
      }
    },
    staleTime: 60_000,
  });
}
